export const units = (state) => state?.entities?.unit;
export const unitsList = (state) =>
  units(state) ? Object.values(units(state)) : [];
